module.exports = __webpack_public_path__ + "static/media/fresh-blue.52fa3d95.png";